import classNames from "classnames";
import { Icon } from "@common/index";
import type { OptionResponse } from "@models/option";

interface OptionValuePillsProps {
    option: OptionResponse;
    pickedValueId: number | undefined;
    onPick: (valueId: number) => void;
}

// The open group's values as pills. The picked pill is filled and shows an x;
// the whole pill is the one control, so clicking it (or its x) un-picks it.
export const OptionValuePills = ({
    option,
    pickedValueId,
    onPick,
}: OptionValuePillsProps) => {
    if (option.values.length === 0) {
        return <p className="text-sm text-neutral">No values.</p>;
    }

    return (
        <div
            role="group"
            aria-label={`${option.name} values`}
            className="flex flex-wrap content-start gap-2"
        >
            {option.values.map((value) => {
                const isPicked = value.id === pickedValueId;
                return (
                    <button
                        key={value.id}
                        type="button"
                        aria-pressed={isPicked}
                        onClick={() => onPick(value.id)}
                        className={classNames(
                            "btn btn-sm rounded-full",
                            isPicked ? "btn-primary" : "btn-outline btn-primary",
                        )}
                    >
                        {value.value}
                        {isPicked && <Icon name="close" className="text-base" />}
                    </button>
                );
            })}
        </div>
    );
};
